/// <amd-module name="Analytics/Shared/Visuals/AreaChartView/Common/Types" />
export interface IAreaChartAggregateData {
    date: string;
    aggrValue: number;
}
